import { texts } from '../../locale'
import { ScreenTitle } from './styled'

export const SilhouettesTitle = () => <ScreenTitle>{texts.title_2}</ScreenTitle>
